
import { CreateRoomPanel } from './lobby/CreateRoomPanel.js?v=GADDAR_YAKALA_UPDATE';
import { JoinRoomPanel } from './lobby/JoinRoomPanel.js';
import { CompetitionPanel } from './lobby/CompetitionPanel.js';

export const LobbyScreen = () => `
        <div id="lobby-screen" class="screen">
            <div class="lobby-header">
                <h2 class="screen-title">ONLİNE LOBİ</h2>
                <div class="online-status-badge">
                    <span class="status-dot"></span>
                    <span id="global-player-count">0 Oyuncu Online</span>
                </div>
            </div>

            <div id="lobby-main-actions" class="lobby-selection-grid">
                <button id="show-competition-btn" class="lobby-type-card competition">
                    <span class="icon">⚔️</span>
                    <span class="title">REKABET ET</span>
                    <span class="desc">Hızlı eşleşme ile yarış!</span>
                </button>
                <button id="show-create-panel-btn" class="lobby-type-card create">
                    <span class="icon">➕</span>
                    <span class="title">ODA KUR</span>
                    <span class="desc">Kendi odanı oluştur ve yönet.</span>
                </button>
                <button id="show-join-panel-btn" class="lobby-type-card join">
                    <span class="icon">🔑</span>
                    <span class="title">ODAYA KATIL</span>
                    <span class="desc">Açık odaları gör veya ID ile katıl.</span>
                </button>
            </div>

            ${CompetitionPanel()}
            ${CreateRoomPanel()}
            ${JoinRoomPanel()}
        </div>
`;

